import {useIntl} from 'react-intl';
import {useLocale} from './useLocale';
import {useTranslateMethod} from './useTranslateMethod';
import {languageFallbackConfigKey} from 'constants/translations';

export const useTranslateRecipe = () => {
  const intl = useIntl();
  const locale = useLocale();
  const translateMethod = useTranslateMethod();

  return <T extends Partial<ToolboxObject.Workshop>>(entity: T) => {
    const translations: Record<string, any> = {};
    const fallbackLanguage = entity.translations?.find((translation) => translation.field_key === languageFallbackConfigKey)?.translation[
      locale
    ] as ToolboxObject.Locale;
    (entity.translations || []).forEach((t) => {
      const {field_key, translation} = t;
      if (field_key in entity && (translation[locale] || (fallbackLanguage && translation[fallbackLanguage]))) {
        translations[field_key] = translation[locale] || translation[fallbackLanguage];
      }
    });

    if (entity.infos) {
      Object.entries(entity.infos).forEach(([key, data]: [string, ToolboxObject.Info[]]) => {
        translations.infos = {
          ...translations.infos,
          [key]: data.map((info) => ({
            ...info,
            description: info.translation?.[locale] || info.description,
          })),
        };
      });
    }

    if (entity.checklist) {
      translations.checklist = entity.checklist.map((item) => ({
        ...item,
        description: item.translation?.[locale] || item.description,
      }));
    }

    if (entity.category) {
      const categoryKey = entity.category.name.split(' ').join('_').toLowerCase();

      translations.category = {
        ...entity.category,
        name: intl.formatMessage({id: `pages.library.category.${categoryKey}`}),
      };
    }

    if (entity.sessions) {
      translations.sessions = entity.sessions.map((session) => ({
        ...session,
        editable_methods: session.editable_methods.map(translateMethod),
      }));
    }

    return {...entity, ...translations} as T;
  };
};
